import {
    RevisionHistoryActionButton,
    RevisionHistoryActionContext
  } from '~src/revisionHistory/interfaces/RevisionHistoryActionContext';
  import { DeleteRevisionAction } from '~src/revisionHistory/services/DeleteRevisionAction';

  import { PublishedConnectionRevision } from '../serverApi/types/PublishedConnectionRevision';

  export namespace RevisionActionPublishedConnection {
    export function getPublishedConnectionRevisionActionButtons(): RevisionHistoryActionButton<PublishedConnectionRevision>[] {
      return [
        deletePublishedConnectionRevisionAction()
      ];
    }

    // action button factories
    function deletePublishedConnectionRevisionAction(): RevisionHistoryActionButton<PublishedConnectionRevision> {
      return {
        name: 'delete',
        translate: 'delete_action',
        execute: (context: RevisionHistoryActionContext<PublishedConnectionRevision>) => {
          DeleteRevisionAction.showDeletePublishedConnectionRevisionDialog(context.selectedItem, context);
        }
      };
    }
  }